import { values } from 'lodash'
import type { DataOperation, Schema } from '@wix/wix-data-schema-types'
import { READ, INSERT, UPDATE, REMOVE } from './allowedOperations'
import {
  readsAllowed,
  insertsAllowed,
  updatesAllowed,
  removalsAllowed,
} from '@wix/wix-data-schema-utils/lib/permission-utils'

/**
 * TODO: get rid of AllowedOperations abstaction and depend on raw schema.allowedOperations
 * values Our abstraction of AllowedOperations is using same terms as Schema permissions,
 * namely: read, insert, update, remove, which will be very confusing
 *
 * Additionally, `serverAllowedOperations` below should never be undefined and the code
 * branch below should be removed
 */
type FixMe_BrokenAllowedOperation =
  | typeof READ
  | typeof INSERT
  | typeof UPDATE
  | typeof REMOVE

export default (
  serverAllowedOperations: DataOperation[] | undefined,
): Array<DataOperation | FixMe_BrokenAllowedOperation> => {
  if (!serverAllowedOperations) {
    return values([READ, INSERT, UPDATE, REMOVE])
  }

  const schemaForPermissionUtils: Schema = {
    allowedOperations: serverAllowedOperations,
  } as Schema

  const allowedOperations: Array<DataOperation | FixMe_BrokenAllowedOperation> =
    [...serverAllowedOperations]

  return allowedOperations
    .concat(readsAllowed(schemaForPermissionUtils) ? [READ] : [])
    .concat(insertsAllowed(schemaForPermissionUtils) ? [INSERT] : [])
    .concat(updatesAllowed(schemaForPermissionUtils) ? [UPDATE] : [])
    .concat(removalsAllowed(schemaForPermissionUtils) ? [REMOVE] : [])
}
